import { useState, useEffect } from "react";
import { Loader2, Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

const Row = ({ l, plans, onDone }) => {
  const [em, setEm] = useState("");
  const [plan, setPlan] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/api/marketing/leads/${l.id}/email`, { email: em });
      if (plan) { const { data } = await api.post("/api/prospects/bulk", { ids: [l.id], action: "subscribe", value: plan, send_invite: false }); toast.success(`${l.business_name}: ${data.message}`); }
      else toast.success(`${l.business_name}: email saved`);
      onDone(l.id);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="grid sm:grid-cols-[1.3fr_1.4fr_150px_auto] gap-2 items-center px-3 py-2" data-testid={`missing-row-${l.id}`}>
      <div className="min-w-0"><p className="font-semibold truncate">{l.business_name}</p><p className="text-xs text-slate-400 truncate">{l.phone || "no phone"}{l.location ? ` · ${l.location}` : ""}</p></div>
      <Input value={em} onChange={e => setEm(e.target.value)} placeholder="Type their email" className="h-9" data-testid={`missing-email-${l.id}`} />
      <select value={plan} onChange={e => setPlan(e.target.value)} className="h-9 border border-slate-300 rounded-md px-2 text-sm" data-testid={`missing-plan-${l.id}`}><option value="">Keep as prospect</option>{plans.map(p => <option key={p.id} value={p.id}>Make {p.name}</option>)}</select>
      <button onClick={save} disabled={busy || !em.trim()} className="bg-blue-600 disabled:opacity-40 text-white h-9 px-3 rounded-md text-sm font-semibold flex items-center justify-center gap-1" data-testid={`missing-save-${l.id}`}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}Save</button>
    </div>
  );
};

export const MissingEmails = () => {
  const [items, setItems] = useState(null);
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    api.get("/api/marketing/missing-emails").then(r => setItems(r.data)).catch(() => setItems([]));
    api.get("/api/public/trial/plans").then(r => setPlans(r.data)).catch(() => {});
  }, []);
  if (!items) return <Loader2 className="w-6 h-6 animate-spin text-blue-600 mx-auto my-10" />;
  return (
    <div className="bg-white border border-slate-200 rounded-xl" data-testid="missing-emails">
      <div className="p-3 border-b"><p className="font-bold text-slate-900" data-testid="missing-count">{items.length} businesses without an email</p><p className="text-xs text-slate-500">Type an email, optionally pick a plan to make them a subscriber, then Save. No login email is sent.</p></div>
      <div className="divide-y text-sm">{items.map(l => <Row key={l.id} l={l} plans={plans} onDone={(id) => setItems(x => x.filter(i => i.id !== id))} />)}
        {items.length === 0 && <p className="p-6 text-center text-slate-400">Everyone has an email</p>}</div>
    </div>
  );
};
